import currency from "currency.js";

export const getFormatNumber = function (num) {
    let res = num, count = num * 1;
    const w = currency(count, {
        precision: 1,
        symbol: "",
    }).divide(10000);
    const q = currency(count, {
        precision: 1,
        symbol: "",
    }).divide(1000);
    if (count > 9999) {
        res = `${w.format()}万+`;
    } else if (count > 999) {
        res = `${q.format()}千+`;
    }
    return res;
}


export const getRandomDuration = function (speed) {
    let res = 5000;
    if(speed && speed.length == 2 && speed[1] - speed[0] > 0) {
        const range = speed[1] - speed[0];
        res = speed[0] + Math.random() * range;
        res = Math.round(res * 1000);
    }
    return res;
}
